import React, { FC } from 'react';
import { Step, Steps } from '@amzn/storm-ui';
import useIntl from '@i18n/useIntl';
import {
  COMBINE_ACCOUNTS_STEP_ACCOUNT_DETAILS_KEY,
  COMBINE_ACCOUNTS_STEP_BILLING_DETAILS_KEY,
  COMBINE_ACCOUNTS_STEP_REVIEW_KEY,
} from '@features/combine-accounts/constants';

export enum CombineAccountsStep {
  AccountDetails = 1,
  BillingDetails = 2,
  Review = 3,
}

const STEP_KEYS: Record<CombineAccountsStep, string> = {
  [CombineAccountsStep.AccountDetails]:
    COMBINE_ACCOUNTS_STEP_ACCOUNT_DETAILS_KEY,
  [CombineAccountsStep.BillingDetails]:
    COMBINE_ACCOUNTS_STEP_BILLING_DETAILS_KEY,
  [CombineAccountsStep.Review]: COMBINE_ACCOUNTS_STEP_REVIEW_KEY,
};

const STEPS = [
  CombineAccountsStep.AccountDetails,
  CombineAccountsStep.BillingDetails,
  CombineAccountsStep.Review,
];

interface CombineAccountsStepsProps {
  current: CombineAccountsStep;
}

const CombineAccountsSteps: FC<CombineAccountsStepsProps> = ({ current }) => {
  const { intl } = useIntl();
  return (
    <Steps current={current}>
      {STEPS.map((step) => (
        <Step
          key={step}
          label={intl.getMessage(STEP_KEYS[step])}
          status={
            step < current
              ? 'completed'
              : step === current
              ? 'active'
              : 'future'
          }
        />
      ))}
    </Steps>
  );
};

export default CombineAccountsSteps;
